<template>
    <div>
        <h2>Reports</h2>
        <div class="container wrapper">
            <table class="table">
                <thead>
                    <tr>
                        <th>Report</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="report in userReportList" :key="report.name">
                        <td>
                            <router-link :to="report.path" tag="a">{{report.name}}</router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    import loggingService from '../services/util/loggingService'
    import roleService from '@/services/roleService.js'
    import userService from '@/services/userService.js'
    import { mapState } from 'vuex'
    import loader from '../components/Loader.vue'

    export default {
        components: {
            loader
        },
        data: function () {
            return {
                isDebug: false,
                adminReports: [
                    { name: 'SHPO Annual Report', path: 'Reports/ShpoAnnualReport' }
                ]
            }
        },
        computed: {
            ...mapState({
                shpoUserDto: state => state.auth.shpoUserDto
            }),
            isAdmin: function () {
                return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.AdminRoleList))
            },
            isConsultant: function () {
                return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.ConsultantUser]))
            },
            isCLGConsultantE106User: function () {
                return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.CLGConsultant, roleService.RoleEnum.E106User]))
            },
            isBlm: function () {
                return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.BlmUser]))
            },
            isShpo: function () {
                return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoRoleList))
            },
            userReportList: function () {
                var reportList = []
                if (this.isAdmin) {
                    reportList = reportList.concat(this.adminReports)
                }
                return reportList
            }
        },
        mounted () {
            loggingService.log(this.isDebug, 'Reports', 'mounted')
        },
        methods: {
        }
    }
</script>



// WEBPACK FOOTER //
// Reports.vue?5f9301ea